@if (initialized && formGroup) {

<div class="surface-section w-full h-screen overflow-auto">
  <h2 class="text-color text-center font-semibold pt-5">Registrierung</h2>
  <stepper [steps]="steps"
           [activeStep]="activeStep"
           [allowStepClick]="false">
  </stepper>

  <ng-container *ngIf="activeStep == 1">
    <ng-container *ngIf="formGroup">
      <registration-personal-info
        [formGroup]="formGroup"
        (handleStepChange)="handleStepChange($event)">
      </registration-personal-info>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="activeStep == 2">
    <ng-container *ngIf="formGroup">
      <registration-address
        [formGroup]="formGroup"
        (handleStepChange)="handleStepChange($event)">
      </registration-address>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="activeStep == 3">
    <ng-container *ngIf="formGroup">
      <registration-notifications
        [formGroup]="formGroup"
        (handleStepChange)="handleStepChange($event)">
      </registration-notifications>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="activeStep == 4">
    <ng-container *ngIf="formGroup">
      <registration-affirmations
        [formGroup]="formGroup"
        (handleStepChange)="handleStepChange($event)">
      </registration-affirmations>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="activeStep == 5">
    <ng-container *ngIf="formGroup">
      <registration-account-setup
        [formGroup]="formGroup"
        (handleStepChange)="handleStepChange($event)">
      </registration-account-setup>
    </ng-container>
  </ng-container>


</div>
}
